export const FETCH_STREAM_PORT_NAME = 'fetch-stream';
